export default (string = "") => string.split("-").join(" ")